module.exports = __webpack_public_path__ + "db04813b59db5b903c1fd9cc08ed49d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/ybicons/iconfont.svg?t=1584093387977
// module id = 1226
// module chunks = 3